/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { Locale } from '../locale/Locale';
import { LocaleKeys } from '../locale/LocaleKeys';
import { GuideError } from './GuideError';

export class TypedChannelsNotFoundError extends GuideError {
    protected title: string = Locale.getString(
        LocaleKeys.GUIDE_TEMPORARY_GUIDE_ISSUE_OVERLAY_TITLE,
    );

    protected type: string = '';

    constructor(code: string, message: string) {
        super(code, message);
        this.code = code;
        this.message = message;
    }

    public getTitle(): string {
        return this.title;
    }

    public getType(): string {
        return this.type;
    }
}
